import React from 'react';
import { TrainWeeklySchedule as TrainWeeklyScheduleType } from '../types';

type TrainWeeklyScheduleProps = {
  trainSchedule: TrainWeeklyScheduleType;
};

export default function TrainWeeklySchedule({ trainSchedule }: TrainWeeklyScheduleProps) {
  return (
    <>
      <span className="hidden">
        {trainSchedule.runningSun === 'Y' ? 'S' : ''}
        {trainSchedule.runningMon === 'Y' ? 'M' : ''}
        {trainSchedule.runningTue === 'Y' ? 'T' : ''}
        {trainSchedule.runningWed === 'Y' ? 'W' : ''}
        {trainSchedule.runningThu === 'Y' ? 'T' : ''}
        {trainSchedule.runningFri === 'Y' ? 'F' : ''}
        {trainSchedule.runningSat === 'Y' ? 'S' : ''}
      </span>
      <span className="latoBold weeklySchedule">
        <span title="Sunday" className={trainSchedule.runningSun === 'Y' ? 'greenText' : ''}>
          S
        </span>
        <span title="Monday" className={trainSchedule.runningMon === 'Y' ? 'greenText' : ''}>
          M
        </span>
        <span title="Tuesday" className={trainSchedule.runningTue === 'Y' ? 'greenText' : ''}>
          T
        </span>
        <span title="Wednesday" className={trainSchedule.runningWed === 'Y' ? 'greenText' : ''}>
          W
        </span>
        <span title="Thursday" className={trainSchedule.runningThu === 'Y' ? 'greenText' : ''}>
          T
        </span>
        <span title="Friday" className={trainSchedule.runningFri === 'Y' ? 'greenText' : ''}>
          F
        </span>
        <span title="Saturday" className={trainSchedule.runningSat === 'Y' ? 'greenText' : ''}>
          S
        </span>
      </span>
    </>
  );
}
